
import {i18n} from '@/common/utils/i18n'
let toast = null

export default {
  computed: {
    loading () {
      return this.$store.state.global.loading
    }
  },
  watch: {
    loading: function (loading) {
      if (loading > 0 && !toast) {
        toast = this.$createToast({
          time: 0,
          txt: i18n.gettext('加载中') + '...',
          mask: true
        })
        toast.show()
      } else if (loading <= 0 && toast) {
        toast.hide()
        toast = null
      }
    }
  }
}
